var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditGreenPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7724 4.23867L11.5288 3.48223C12.3099 2.70118 13.5762 2.70118 14.3572 3.48223L14.7108 3.83579C15.4918 4.61683 15.4918 5.88317 14.7108 6.66421L13.9543 7.42065M10.7724 4.23867L3.68913 11.3219C3.35706 11.654 3.15243 12.0923 3.11111 12.5601L2.9718 14.1371C2.91703 14.7571 3.4359 15.276 4.05591 15.2212L5.63289 15.0819C6.1007 15.0406 6.53904 14.836 6.87111 14.5039L13.9543 7.42065M10.7724 4.23867L13.9543 7.42065",
    stroke: "#01533B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreenPencil);
export default __webpack_public_path__ + "static/media/edit-green-pencil.fab2527a618aa0932e8f731d1ed94103.svg";
export { ForwardRef as ReactComponent };